import { Result } from 'result-type-ts';
import i18n from 'sveltekit-i18n';
import { config } from '$lib/translations/generated/translations';
import { PUBLIC_BASE_PATH } from '$env/static/public';

export const CONFIG_FILE = 'translations.json' as const;
export const languages = ['ja', 'zh-cn', 'zh-tw'] as const;
export type Language = typeof languages[number];
function isLanguage(value: string): value is Language
{
    return (languages as readonly string[]).includes(value);
}

export type SerializedConfig = {
    loaders: {
        locale: string;
        key: string;
        loader: string;
    }[];
};

export const { t, locale, locales, loading, loadTranslations } = new i18n(config);

export function getLangUrl(url: URL): string
{
    let { pathname } = url;
    pathname = pathname.replace(new RegExp(PUBLIC_BASE_PATH), '');
    const lang = pathname.split('/')[1];
    return `${PUBLIC_BASE_PATH}/${lang}`;
}

export function getLang(url: URL): Result<Language>
{
    let { pathname } = url;
    pathname = pathname.replace(new RegExp(PUBLIC_BASE_PATH), '');
    const lang = pathname.split('/')[1]; // パスの最初のセグメントを取得

    // 言語が有効かどうかをチェック
    if (isLanguage(lang))
    {
        return Result.success(lang);
    } else
    {
        return Result.failure("Invalid language in URL");
    }
}
